"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/goods/v1/internal_service.proto (package spwn.goods.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalGoodsService = void 0;
const internal_service_pb_1 = require("./internal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.goods.v1.InternalGoodsService
 */
exports.InternalGoodsService = {
    typeName: "spwn.goods.v1.InternalGoodsService",
    methods: {
        /**
         * グッズの在庫を確保する
         *
         * @generated from rpc spwn.goods.v1.InternalGoodsService.AllocateGoodsInventory
         */
        allocateGoodsInventory: {
            name: "AllocateGoodsInventory",
            I: internal_service_pb_1.InternalGoodsServiceAllocateGoodsInventoryRequest,
            O: internal_service_pb_1.InternalGoodsServiceAllocateGoodsInventoryResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 確保していた在庫を解放する
         *
         * @generated from rpc spwn.goods.v1.InternalGoodsService.ReleaseGoodsInventory
         */
        releaseGoodsInventory: {
            name: "ReleaseGoodsInventory",
            I: internal_service_pb_1.InternalGoodsServiceReleaseGoodsInventoryRequest,
            O: internal_service_pb_1.InternalGoodsServiceReleaseGoodsInventoryResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 在庫が確保できるかどうかの確認をする
         *   実際には在庫の確保はしないので在庫が確保時には再度確認が必要
         *
         * @generated from rpc spwn.goods.v1.InternalGoodsService.GetInventoryStatus
         */
        getInventoryStatus: {
            name: "GetInventoryStatus",
            I: internal_service_pb_1.InternalGoodsServiceGetInventoryStatusRequest,
            O: internal_service_pb_1.InternalGoodsServiceGetInventoryStatusResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * バリエーションを単体取得する
         *
         * @generated from rpc spwn.goods.v1.InternalGoodsService.GetGoodsVariant
         */
        getGoodsVariant: {
            name: "GetGoodsVariant",
            I: internal_service_pb_1.InternalGoodsServiceGetGoodsVariantRequest,
            O: internal_service_pb_1.InternalGoodsServiceGetGoodsVariantResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * バリエーションの一覧を取得する
         *
         * @generated from rpc spwn.goods.v1.InternalGoodsService.GetGoodsVariants
         */
        getGoodsVariants: {
            name: "GetGoodsVariants",
            I: internal_service_pb_1.InternalGoodsServiceGetGoodsVariantsRequest,
            O: internal_service_pb_1.InternalGoodsServiceGetGoodsVariantsResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * brandに属するグッズ一覧(variantsを含めた)を取得する
         *
         * @generated from rpc spwn.goods.v1.InternalGoodsService.GetAllGoodsByBrand
         */
        getAllGoodsByBrand: {
            name: "GetAllGoodsByBrand",
            I: internal_service_pb_1.InternalGoodsServiceGetAllGoodsByBrandRequest,
            O: internal_service_pb_1.InternalGoodsServiceGetAllGoodsByBrandResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=internal_service_connect.js.map